/**
 * AudioStreamPlayer strict validators. `playback_type` shares its bound with AudioStreamPlayer3D's:
 * both forward into AudioStreamPlayerInternal::set_playback_type
 * (audio_stream_player_internal.cpp:337-339) and the same AudioServer::PlaybackType enum
 * (audio_server.h:194-199, "Default,Stream,Sample").
 */
// The base chain. Registration happens on import, so a test that loads only this slice resolves
// an inherited key only when the ancestor is imported too.
import '../../node/linterParser.js';
import { validatorRegistry } from '../../../linter/ValidatorRegistry.js';
import { v } from '../../../linter/validators/index.js';
import { busValidator } from '../busValidator.js';
import { AUDIO_SERVER_PLAYBACK_TYPE_NAMES } from '../../../godot/audio/audioServer.js';
import { AUDIO_STREAM_PLAYER_MIX_TARGET_NAMES } from '../../../godot/scene/audio.js';
validatorRegistry.registerAll('AudioStreamPlayer', {
    stream: v.resourceReference('stream'),
    // audio_stream_player.cpp:282, PROPERTY_HINT_RANGE "-80,24,suffix:dB": both ends closed, and
    // set_volume_db assigns straight through, so out of range warns. Its one refusal is
    // ERR_FAIL_COND_MSG(Math::is_nan(p_volume), ...): `nan` is dropped and the field keeps its
    // previous value, while `inf` and `-inf` are stored unaltered.
    volume_db: v.float('volume_db', {
        min: -80,
        max: 24,
        hinted: 'audio_stream_player.cpp:282',
        nan: 'audio_stream_player.cpp:70',
    }),
    // audio_stream_player_internal.cpp:314, ERR_FAIL_COND(p_pitch_scale <= 0.0),
    // against a hint (audio_stream_player.cpp:284) of
    // "0.01,4,0.01,or_greater", where `or_greater` opens the ceiling. The two floors
    // sit apart, so (0, 0.01) loads into Godot and only warns.
    pitch_scale: v.positiveFloat('pitch_scale', undefined, {
        min: 0.01,
        enforced: 'audio_stream_player_internal.cpp:314',
        hinted: 'audio_stream_player.cpp:284',
    }),
    playing: v.boolean('playing'),
    autoplay: v.boolean('autoplay'),
    stream_paused: v.boolean('stream_paused'),
    bus: busValidator,
    // audio_stream_player_internal.cpp:323 drops the write when <= 0.
    max_polyphony: v.int('max_polyphony', { min: 1, enforced: 'audio_stream_player_internal.cpp:323' }),
    // audio_stream_player.cpp:288, PROPERTY_HINT_ENUM "Stereo,Surround,Center".
    // set_mix_target (:161-163) is a bare assignment: out-of-range only warns.
    mix_target: v.enumInt('mix_target', AUDIO_STREAM_PLAYER_MIX_TARGET_NAMES, {
        hinted: 'audio_stream_player.cpp:288',
    }),
    // audio_stream_player.cpp:291, PROPERTY_HINT_ENUM "Default,Stream,Sample".
    // set_playback_type (:234-236) forwards to
    // AudioStreamPlayerInternal::set_playback_type (audio_stream_player_internal.cpp:337-339),
    // a bare assignment: out-of-range only warns.
    playback_type: v.enumInt('playback_type', AUDIO_SERVER_PLAYBACK_TYPE_NAMES, {
        hinted: 'audio_stream_player.cpp:291',
    }),
});
//# sourceMappingURL=linterParser.js.map